import { geom } from "@examspark/common";
import { Cartesian, Stem, StemCartesianInequality } from "@examspark/types";

import { coordsAreEqual } from "./graphing/common";
import { getNewScore } from "./utils";

export const scoreCartesianInequality = (
  expected: StemCartesianInequality,
  actual: Partial<Stem.Response>,
) => {
  const { scoring, config } = expected;
  const score = getNewScore();
  score.max = scoring?.shapes?.length ? scoring.shapes.length + 1 : 0;
  if (!actual?.shapes) return score;
  if (!scoring?.shapes) return score;

  const lines_are_correct = scoring.shapes.map((expectedShape) => {
    const findModelShape = actual?.shapes?.find((actualShape) => {
      return linesAreEqual(expectedShape, actualShape, config);
    });

    return !!findModelShape;
  });

  const all_lines_are_correct = lines_are_correct.reduce(
    (prev, curr) => prev && curr,
    true,
  );
  const quadrant_is_correct =
    scoring?.inequality?.quadrant === actual.inequality?.quadrant;

  // one point per correct line
  score.actual += lines_are_correct.filter(Boolean).length;

  // one point for the correct quadrant IF all lines were correct
  if (all_lines_are_correct && quadrant_is_correct) {
    score.actual += 1;
  }

  return score;
};

const linesAreEqual = (
  actualShape: Cartesian.Shape,
  expectedShape: Cartesian.Shape,
  config: StemCartesianInequality["config"],
) => {
  if (actualShape.type !== expectedShape.type) return false;

  if (
    (actualShape.type === "dashed-line" || actualShape.type === "line") &&
    (expectedShape.type === "line" || expectedShape.type === "dashed-line")
  ) {
    //
    const actualLineCoordinates = geom.calculateLineCoordinates({
      shape: actualShape,
      x: config.graph.x,
      y: config.graph.y,
    });

    const expectedLineCoordinates = geom.calculateLineCoordinates({
      shape: expectedShape,
      x: config.graph.x,
      y: config.graph.y,
    });

    if (!actualLineCoordinates || !expectedLineCoordinates) return false;

    return (
      (coordsAreEqual(actualLineCoordinates[0], expectedLineCoordinates[0]) &&
        coordsAreEqual(actualLineCoordinates[1], expectedLineCoordinates[1])) ||
      (coordsAreEqual(actualLineCoordinates[0], expectedLineCoordinates[1]) &&
        coordsAreEqual(actualLineCoordinates[1], expectedLineCoordinates[0]))
    );
  } else {
    return false;
  }
};
